// extracted by mini-css-extract-plugin
module.exports = {"aboveSearchPosition":"ReviewSummary_aboveSearchPosition__VcdAu"};